import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const EmojiLevel4 = (props: SvgProps) => {
  return (
    <Svg viewBox="0 0 40 40" fill="none" {...props}>
      <Path
        d="M20 38c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18z"
        fill="#EFD482"
        stroke="#11494F"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13 18.25a3 3 0 100-6 3 3 0 000 6zM26.5 18.25a3 3 0 100-6 3 3 0 000 6z"
        fill="#11494F"
      />
      <Path
        d="M27.8 23.5a9.019 9.019 0 01-15.6 0"
        stroke="#11494F"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default EmojiLevel4
